// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GEWb","footer":"styles_footer__1n2XZ"};